/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { BlueLine, Button, HeadingH2, HeadingH3, Text } from 'components/landing/ui';
import { arrowRight } from 'components/landing/ui/icons';
import { Link as RouterLink } from 'react-router-dom';

export const Dot = styled('div')({
  width: 10,
  height: 10,
  background: '#000',
  marginRight: 15,
  borderRadius: '50%',
  flexShrink: 0,
});

const LeftCol = () => (
  <div
    css={{
      flexDirection: 'column',
      alignItems: 'center',
      '@media (min-width:992px)': { alignItems: 'flex-start' },
    }}
  >
    <HeadingH2 css={{ marginBottom: 20 }}>Как сервис приведет Вам клиентов?</HeadingH2>
    <BlueLine width={125} height={5} css={{ marginBottom: 40 }} />
    <HeadingH3 css={{ marginBottom: 30 }}>Будет делать за Вас:</HeadingH3>

    <div
      css={{
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 30,
        '>div': { alignItems: 'center' },
        '>div:not(:last-of-type)': { marginBottom: 20 },
        '@media (min-width:992px)': { alignItems: 'flex-start', marginBottom: 60 },
        '@media (min-width:1366px)': { marginBottom: 80 },
      }}
    >
      <div>
        <Dot />
        <Text>Привлекать новую аудиторию</Text>
      </div>
      <div>
        <Dot />
        <Text>Делать ненавязчивые продажи</Text>
      </div>
      <div>
        <Dot />
        <Text>Возвращать и удерживать подписчиков</Text>
      </div>
      <div>
        <Dot />
        <Text>Создавать активность и повышать лояльность</Text>
      </div>
    </div>

    {/* <RouterLink to="/lk" target="_blank">
    </RouterLink> */}
    <Button
      type="blue"
      icon={arrowRight}
      onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
    >
      Попробовать бесплатно
    </Button>
  </div>
);

export default LeftCol;
